import {createLog} from 'OK/banners/bannerNew/utils/BannerCommon';
import {JSEvaluatorJs} from 'OK/banners/bannerNew/utils/JSEvaluatorJs';
import * as logger from 'OK/logger';

const evaluator: JSEvaluatorJs = new JSEvaluatorJs();
const log = createLog('HtmlRendererJs');
let injection = false;

const DEFAULT_DEPTH = 3;
const DEFAULT_FROM = 64;

evaluator.logError = (script: HTMLScriptElement, ex: Error) => {
    const jsplace = JSEvaluatorJs.findNearestPlace(script, DEFAULT_DEPTH) || "unknown";
    const message = ex.message ? ex.message.substr(DEFAULT_FROM) : '';
    logger.trace("testing", ex.stack!, "jsban_" + jsplace, message);
};

export class HtmlRendererJs {

    log = createLog('HtmlRendererJs');

    setBannerPlace(element: HTMLElement, position: number) {
        element.setAttribute(JSEvaluatorJs.JSPLACE_ATTR_NAME, "p" + position);
    }

    setBannerHtml(element: HTMLElement, html: string) {
        injection = true;
        this.log('setBannerHtml', {
            el: element,
            html: html
        });
        element.innerHTML = html;
        evaluator.findAndEvalScripts(element);
        injection = false;
    }

    static isInjection() {
        return injection;
    }
}